var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],class:['classroom-title', _vm.name],style:({ backgroundImage: `url(${_vm.$images.my_classroom_title_sprites})` })})
}
var staticRenderFns = []

export { render, staticRenderFns }